var _a;
const bytecloudContext = (_a = window.getBytecloudContext) == null ? void 0 : _a.call(window, "bytecloud-volcengine");
export {
  bytecloudContext
};
